import { Vue } from 'vue-property-decorator';
import { CategoryFacetDto, PageMetadataDto, PageRequestDto, ProductFacetsDto, ProductSearchFilterDto } from '@/api';
import BrowseStore from '@/stores/product/browse.store';
import { ProductGrouping, SearchUtility } from '@/stores/search/util';
import { SortSetting, SortUtils } from '@/util/SortUtils';

export default abstract class AbstractBrowsePage extends Vue {
  protected abstract store: BrowseStore;
  private currentSortSettingId = '1';

  get loadingNewResult(): boolean {
    return this.store.isLoading;
  }

  get loadingNewPage(): boolean {
    return this.store.isLoadingNewPage;
  }

  get distinctProductCount(): number {
    return this.store.currentDistinctProductCount;
  }

  get productGroupings(): ProductGrouping[] {
    return this.store.currentSearchResult?.groupings ?? [];
  }

  get searchFilter(): ProductSearchFilterDto {
    return this.store.currentSearchRequest.filter!;
  }

  get resultFacets(): ProductFacetsDto {
    return this.store.currentSearchResult.facets;
  }

  get parentCategoryFacets(): CategoryFacetDto[] {
    return this.store.currentSearchResult.facets.parentCategoryFacets || [];
  }

  get childCategoryFacets(): CategoryFacetDto[] {
    return this.store.currentSearchResult.facets.childCategoryFacets || [];
  }

  get sortSettings(): SortSetting[] {
    return SortUtils.getBrowseSortSettings();
  }

  get sortSetting(): string {
    return this.currentSortSettingId;
  }

  get pageRequest(): PageRequestDto {
    return this.store.currentSearchRequest.page ?? SearchUtility.EmptyPageRequest;
  }

  get currentPageMeta(): PageMetadataDto | null {
    return this.store.currentSearchResult?.page ?? SearchUtility.EmptyPageResult;
  }

  public async updateFilter(newFilter: ProductSearchFilterDto): Promise<void> {
    const searchRequest = this.store.currentSearchRequest;
    searchRequest.filter = newFilter;
    await this.store.updateSearchRequest(searchRequest);
  }

  public async fetchAdditionalPage(page: PageMetadataDto): Promise<void> {
    await this.store.fetchAdditionalPage(page);
  }

  public async updateSortSetting(newSortSettingId: string) {
    this.currentSortSettingId = newSortSettingId;
    const newSetting = this.sortSettings.find((s) => s.id === newSortSettingId);
    await this.store.updateSorting(newSetting ? newSetting : {fieldName: undefined, direction: undefined});
  }

  public async updateCategory(categoryId: string) {
    await this.store.updateCategory(categoryId);
  }
}
